import{pathBuilder}from'config/paths/index';// TEMPLATE TODO: Update for Feature
export var root='/admin/badges';export default pathBuilder(root);